import { getRequest } from '../services/requestHandler';
import { PlayerStatusLookup } from '../models';

export const getPlayerStatusLookups = async () => {
  const url = 'player/getPlayerStatusLookups?activeOnly=true&useCache=true';
  const response = await getRequest<PlayerStatusLookup>('GetPlayerStatusLookups', url);
  return response;
};
